import CallServer from '../../api/CallServerV2';
export async function fetchUsers (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_users',
    })
} 

export async function fetchUser (user_id) {
    return await CallServer({
        params: {
            user_id: user_id
        },
        endpoint: '/admin/get_user',
        isGet: true
    })
} 

export async function fetchUserAccess (user_id) {
    return await CallServer({
        params: {
            user_id: user_id
        },
        endpoint: '/admin/get_user_accessible_materials',
        isGet: true
    })
} 

export async function fetchGroups (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/get_groups',
    })
} 

export async function fetchGroup (group_id) {
    return await CallServer({
        params: {
            group_id: group_id
        },
        endpoint: '/admin/get_group'
    })
} 

export async function fetchGroupAccess (group_id) {
    return await CallServer({
        params: {
            group_id: group_id
        },
        endpoint: '/admin/get_group_accessible_materials',
        isGet: true
    })
} 

export async function fetchUsersAuthSettings () {
    return await CallServer({
        endpoint: '/admin/get_auth_settings',
    })
} 

export async function fetchUsersFields () {
    return await CallServer({
        endpoint: '/admin/get_profile_fields',
    })
} 

export async function fetchUpdateUsersAuthSettings (auth_data) {
    return await CallServer({
        endpoint: '/admin/update_auth_settings',
        body: auth_data
    })
} 

export async function fetchUpdateProfileFields (fields_data) {
    return await CallServer({
        endpoint: '/admin/add_profile_fields',
        body: fields_data
    })
}

export async function approveUsers (users_data) {
    return await CallServer({
        body: users_data,
        endpoint: '/admin/approve_users',
    })
} 

export async function rejectUsers (users_data) {
    return await CallServer({
        body: users_data,
        endpoint: '/admin/reject_users',
    })
} 

export async function searchUsers (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/search_users',
    })
} 

export async function searchGroups (params = {}) {
    return await CallServer({
        params: params,
        endpoint: '/admin/search_groups',
    })
} 

export async function updateUserData (user_data) {
    return await CallServer({
        body: user_data,
        endpoint: '/admin/update_user',
    })
} 

export async function suspendUsers (users_data) {
    return await CallServer({
        body: users_data,
        endpoint: '/admin/suspend_users',
    })
} 

export async function deleteUsers (users_data) {
    return await CallServer({
        body: users_data,
        endpoint: '/admin/delete_users',
    })
} 

export async function fetchCreateNewGroup (group_data) {
    return await CallServer({
        body: group_data,
        endpoint: '/admin/create_new_group',
    })
} 

export async function fetchEditGroup (group_data) {
    return await CallServer({
        body: group_data,
        endpoint: '/admin/update_group',
    })
} 

export async function addUsersToGroup (params, users_data) {
    return await CallServer({
        params: params,
        body: users_data,
        endpoint: '/admin/add_users_to_group',
    })
} 

export async function removeUsersToGroup (params, users_data) {
    return await CallServer({
        params: params,
        body: users_data,
        endpoint: '/admin/remove_users_from_group',
    })
} 

export async function addAdminsToGroup (params, users_data) {
    return await CallServer({
        params: params,
        body: users_data,
        endpoint: '/admin/add_admins_to_group',
    })
} 

export async function removeAdminsToGroup (params, users_data) {
    return await CallServer({
        params: params,
        body: users_data,
        endpoint: '/admin/remove_admins_from_group',
    })
} 

export async function fetchGrantAdminRole (user_data) {
    return await CallServer({
        body: user_data,
        endpoint: '/admin/grant_admin_role',
    })
} 

export async function fetchRevokeAdminRole (user_id) {
    return await CallServer({
        params: {
            'user_id': user_id
        },
        endpoint: '/admin/revoke_admin_role',
    })
} 

export async function fetchAddSuperAdmin (email) {
    return await CallServer({
        params: {
            user_email: email
        },
        body: {},
        customUrl: true,
        endpoint: 'http://127.0.0.1:8000/api/add_new_super_admin',
    })
} 